module.exports = __webpack_public_path__ + "static/media/flecheLiRouge.aa467d86.svg";